"use client";
import { cn as e } from "../../lib/utils.js";
import { LoaderIcon as t } from "../../icons.js";
import { tv as n } from "tailwind-variants";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
//#region src/components/Button/Button.tsx
var a = n({
	base: "font-ic-web-body focus-visible:ring-ic-web-primary/50 relative inline-flex cursor-pointer items-center justify-center gap-2 rounded-md font-medium whitespace-nowrap transition-colors select-none focus-visible:ring-2 focus-visible:outline-none active:translate-y-px aria-disabled:pointer-events-none aria-disabled:opacity-70",
	variants: {
		variant: {
			primary: "",
			secondary: "",
			outline: "border border-solid",
			subtle: "bg-transparent"
		},
		size: {
			xs: "h-7 px-3.5 text-xs",
			sm: "h-8 px-4 text-sm",
			md: "h-10 px-5 text-base",
			lg: "h-12 px-7 text-lg"
		},
		color: {
			instacover: "",
			gray: "",
			danger: ""
		},
		iconOnly: { true: "px-0" }
	},
	compoundVariants: [
		{
			color: "instacover",
			variant: "primary",
			class: "bg-ic-web-primary text-ic-web-on-primary hover:bg-ic-web-primary/90"
		},
		{
			color: "instacover",
			variant: "secondary",
			class: "bg-ic-web-primary/15 text-ic-web-primary-text hover:bg-ic-web-primary/25"
		},
		{
			color: "instacover",
			variant: "outline",
			class: "border-ic-web-primary-text bg-ic-web-background text-ic-web-primary-text hover:bg-ic-web-primary/10"
		},
		{
			color: "instacover",
			variant: "subtle",
			class: "text-ic-web-primary-text hover:bg-ic-web-primary/10"
		},
		{
			color: "gray",
			variant: "primary",
			class: "bg-ic-web-heading text-ic-web-background hover:bg-ic-web-heading/80"
		},
		{
			color: "gray",
			variant: "secondary",
			class: "bg-ic-web-background-muted text-ic-web-heading hover:bg-ic-web-border/50"
		},
		{
			color: "gray",
			variant: "outline",
			class: "border-ic-web-border bg-ic-web-background text-ic-web-heading hover:bg-ic-web-background-muted"
		},
		{
			color: "gray",
			variant: "subtle",
			class: "text-ic-web-heading hover:bg-ic-web-background-muted"
		},
		{
			color: "danger",
			variant: "primary",
			class: "bg-ic-web-error hover:bg-ic-web-error/90 text-white"
		},
		{
			color: "danger",
			variant: "secondary",
			class: "bg-ic-web-error/15 text-ic-web-error-text hover:bg-ic-web-error/25"
		},
		{
			color: "danger",
			variant: "outline",
			class: "border-ic-web-error-text bg-ic-web-background text-ic-web-error-text hover:bg-ic-web-error/10"
		},
		{
			color: "danger",
			variant: "subtle",
			class: "text-ic-web-error-text hover:bg-ic-web-error/10"
		},
		{
			iconOnly: !0,
			size: "xs",
			class: "w-7"
		},
		{
			iconOnly: !0,
			size: "sm",
			class: "w-8"
		},
		{
			iconOnly: !0,
			size: "md",
			class: "w-10"
		},
		{
			iconOnly: !0,
			size: "lg",
			class: "w-12"
		}
	],
	defaultVariants: {
		variant: "primary",
		size: "md",
		color: "instacover"
	}
}), o = n({
	base: "animate-spin",
	variants: { size: {
		xs: "size-3",
		sm: "size-4",
		md: "size-5",
		lg: "size-6"
	} },
	defaultVariants: { size: "md" }
});
function s({ as: n, className: s, variant: c, size: l, color: u, iconOnly: d, loading: f, disabled: p, onClick: m, children: h, ...g }) {
	let _ = n ?? "button", v = !!(f || p);
	function y(e) {
		if (v) {
			e.preventDefault();
			return;
		}
		m?.(e);
	}
	return /* @__PURE__ */ i(_, {
		...g,
		"aria-disabled": v || void 0,
		"aria-busy": f || void 0,
		className: a({
			variant: c,
			size: l,
			color: u,
			iconOnly: d,
			className: s
		}),
		onClick: y,
		children: [/* @__PURE__ */ r("span", {
			className: e("contents", f && "invisible"),
			children: h
		}), f && /* @__PURE__ */ r("span", {
			className: "absolute inset-0 flex items-center justify-center",
			children: /* @__PURE__ */ r(t, { className: o({ size: l }) })
		})]
	});
}
//#endregion
export { s as Button, a as buttonVariants };
